import React from 'react'
import {ElementsConsumer} from '@stripe/react-stripe-js'

import Topup from '../Topup'

const InjectedTopup = () => {
    return (
        <ElementsConsumer>
            {({elements, stripe}) => (
                <Topup elements={elements} stripe={stripe} />
            )}
        </ElementsConsumer>
    )
}

export default InjectedTopup